import { inject, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'categoria',
  standalone: true
})
export class CategoriaPipe implements PipeTransform {

  categoria: any[] = [
    { "id": 0, "name": "Extemporaneo" },
    { "id": 1, "name": "Normal" },
    { "id": 2, "name": "Personal" },
    { "id": 3, "name": "Urgente" },
  ]

  transform(id: number): string {
    if (id == null) return '';
    return this.categoria[id].name;
  }

}
